import { render } from "./CourseDetail.vue?vue&type=template&id=57245354&scoped=true"
import script from "./CourseDetail.vue?vue&type=script&lang=js"
export * from "./CourseDetail.vue?vue&type=script&lang=js"

import "./CourseDetail.vue?vue&type=style&index=0&id=57245354&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57245354"]])

export default __exports__